// extracted by mini-css-extract-plugin
export default {"min-h-100px":"TableBottom_min-h-100px__OWTYI"};